/**
 * Documentation MARIDA API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateUserRequest { 
    /**
     * First name
     */
    firstname: string;
    /**
     * Last name
     */
    lastname: string;
    /**
     * Email
     */
    email: string;
    /**
     * password
     */
    password: string;
    /**
     * Confirmation password
     */
    passwordConfirmation: string;
    /**
     * Birth date
     */
    birthDate?: string;
    /**
     * gender
     */
    gender?: string;
    /**
     * Phone
     */
    phone?: string;
    /**
     * addressStreet
     */
    addressStreet?: string;
    /**
     * addressNumber
     */
    addressNumber?: string;
    /**
     * addressCountry
     */
    addressCountry?: string;
    /**
     * addressCity
     */
    addressCity?: string;
    /**
     * addressZip
     */
    addressZip?: string;
}

